import React from "react";
import { Typography, Box } from "@material-ui/core";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { formatNota } from "../../utils/formato";

const tooltipEstilo = {
  background: "#ffffff",
  color: "#0f172a",
  border: "none",
  borderRadius: 10,
  padding: "8px 12px",
  fontSize: 12,
  fontWeight: 700,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
};

const RadarTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) return null;
  const item = payload[0];
  const label = item?.payload?.subject ?? "";
  const val = item?.value;
  const texto = formatNota(val);
  return (
    <div style={tooltipEstilo}>
      {label}: {texto}
    </div>
  );
};

const GraficaRadarCompetencias = ({ data, height = 168 }) => {
  const chartData = data && data.length ? data : [];
  const outerR = Math.min(Math.round(height * 0.36), 70);

  return (
    <Box bgcolor="#ffffff" borderRadius={12} boxShadow="0 1px 8px rgba(0, 0, 0, 0.08)" p={1.25}>
      <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a" }}>
        Desempeño por competencias
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 8, fontSize: 11, lineHeight: 1.4 }}>
        Gráfica de radar del último intento del estudiante en escala de 0 al 5.
      </Typography>
      <Box borderRadius={10} style={{ padding: "6px 8px 10px", overflow: "visible" }}>
        <ResponsiveContainer width="100%" height={height}>
          <RadarChart
            cx="50%"
            cy="54%"
            outerRadius={outerR}
            data={chartData}
            margin={{ top: 22, right: 18, bottom: 20, left: 18 }}
          >
            <PolarGrid
              gridType="polygon"
              radialLines
              stroke="#cbd5e1"
              strokeWidth={0.85}
            />
            <PolarAngleAxis
              dataKey="subject"
              tick={{ fill: "#334155", fontSize: 9, fontWeight: 700 }}
              tickLine={false}
            />
            <PolarRadiusAxis
              domain={[0, 5]}
              ticks={[0, 1, 2, 3, 4, 5]}
              tick={{ fill: "#64748b", fontSize: 9, fontWeight: 600 }}
              axisLine={false}
            />
            <Tooltip content={<RadarTooltip />} />
            {chartData.length > 0 && (
              <Radar
                name="Nivel"
                dataKey="value"
                stroke="#2563eb"
                strokeWidth={2.5}
                fill="#3b82f6"
                fillOpacity={0.28}
                dot={{
                  r: 5,
                  fill: "#2563eb",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
                activeDot={{
                  r: 7,
                  fill: "#1d4ed8",
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
                isAnimationActive
              />
            )}
          </RadarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default GraficaRadarCompetencias;
